
import React from 'react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="mx-auto max-w-4xl py-12 px-6">
        <div className="mb-8 flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-black text-slate-900 tracking-tight mb-2">Privacy Policy</h1>
            <p className="text-slate-500 font-medium italic text-sm">Last updated: March 2026</p>
          </div>
          <button
            onClick={() => navigate(-1)}
            className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-slate-500 shadow-sm border border-slate-200 hover:text-[#136bce] hover:border-[#136bce] transition-all group"
          >
            <span className="material-symbols-outlined transition-transform group-hover:-translate-x-0.5">arrow_back</span>
          </button>
        </div>

        <div className="prose prose-slate max-w-none bg-white rounded-2xl border border-slate-200 p-8 shadow-sm">
          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-800 mb-4 border-l-4 border-[#136bce] pl-3">Introduction</h2>
            <p className="text-slate-600 leading-relaxed">
              QA MATE Systems ("we," "us," or "our") operates the QA MATE Inspect Pro platform, including our mobile applications and dashboard. This Privacy Policy informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-800 mb-4 border-l-4 border-[#136bce] pl-3">Information Collection and Use</h2>
            <p className="text-slate-600 mb-4">We collect several different types of information for various purposes to provide and improve our Service to you.</p>
            <ul className="list-disc pl-5 space-y-2 text-slate-600">
              <li><strong>Camera Usage:</strong> Our mobile app requires access to your device's camera to take inspection evidence photos and scan barcodes.</li>
              <li><strong>Location Data:</strong> We may use and store information about your location if you give us permission to do so. We use this data to verify the site of inspection.</li>
              <li><strong>Personal Data:</strong> While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you, such as your email address, full name, and employee ID.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-800 mb-4 border-l-4 border-[#136bce] pl-3">Data Protection</h2>
            <p className="text-slate-600 leading-relaxed">
              The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.
            </p>
          </section>

          <section className="mb-8 bg-red-50 p-6 rounded-xl border border-red-100">
            <h2 className="text-xl font-bold text-red-800 mb-4 border-l-4 border-red-500 pl-3">Data Retention and Deletion</h2>
            <p className="text-slate-700 font-bold mb-3">You have the right to request the deletion of your account and all associated data at any time.</p>
            <ul className="list-disc pl-5 space-y-2 text-slate-700 text-sm">
              <li>Upon initiating an account deletion request through the mobile app or dashboard, all personal data, inspection reports, and pending actions associated with your profile will be <strong>deleted immediately and permanently</strong>.</li>
              <li>Once an account is deleted, QA MATE <strong>will not retain any data</strong> related to that specific user ID in our production systems.</li>
              <li>This action is irreversible and system access will be terminated immediately.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-800 mb-4 border-l-4 border-[#136bce] pl-3">Changes to This Privacy Policy</h2>
            <p className="text-slate-600 leading-relaxed">
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "last updated" date.
            </p>
          </section>

          <div className="mt-12 flex justify-center">
            <button
              onClick={() => navigate(-1)}
              className="inline-flex items-center gap-2 rounded-lg bg-[#136bce] px-8 py-3 text-sm font-bold text-white shadow-lg shadow-blue-500/30 hover:bg-blue-700 transition-all transform active:scale-95"
            >
              <span className="material-symbols-outlined text-[20px]">arrow_back</span>
              Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
